var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAoa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0641 11.6031L9.0788 17.901C8.97299 17.9837 8.8178 17.9913 8.71199 17.9085L0.599752 11.7912C0.444562 11.6708 0.409291 11.43 0.536265 11.272L8.51447 1.06892C8.62734 0.918433 8.83896 0.918433 8.95888 1.06892L17.1064 11.2118C17.1981 11.3322 17.184 11.5128 17.0641 11.6031Z",
    fill: "#FFF4FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6343 11.3909L9.04407 17.3728L9.00175 11.2781L8.94531 1.70703L16.4579 11.1652L16.6343 11.3909Z",
    fill: "url(#paint0_linear_452_5641)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.910156 11.5188L8.6979 17.3728L8.52155 1.70703L0.910156 11.5188Z",
    fill: "url(#paint1_linear_452_5641)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63441 11.2949L0.966589 11.4529L0.910156 11.5207L8.6979 17.3746L8.63441 11.2949Z",
    fill: "url(#paint2_linear_452_5641)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00098 11.2799L16.4572 11.167L16.6335 11.3927L9.0433 17.3746L9.00098 11.2799Z",
    fill: "url(#paint3_linear_452_5641)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00143 11.2039L16.4576 11.091M8.63462 11.219L0.966797 11.377M8.59935 8.54779C6.94869 7.20093 6.25033 6.99025 5.98933 7.21598C5.26981 7.85555 7.93626 12.0165 6.87109 13.0624C6.56071 13.3634 5.91879 13.4311 4.68432 13.559C4.30339 13.5967 3.98596 13.6117 3.78139 13.6117M11.5198 11.1663L8.98733 8.80362M7.3155 3.19043C7.29434 3.55912 7.30845 4.28899 7.66115 5.0941C7.94332 5.7412 8.33129 6.16256 8.57819 6.39582M14.6306 12.8969C14.6941 12.7991 15.4842 11.5576 14.9974 10.3913C14.6377 9.52597 13.7559 9.12717 13.6219 9.06698C13.4455 8.98421 13.4385 9.00678 12.6131 8.72086C12.1123 8.54027 11.8584 8.4575 11.6397 8.36721C11.3011 8.23177 10.645 7.96089 9.89731 7.44923C9.65041 7.2837 9.33298 7.04292 8.97322 6.72689",
    stroke: "#98C9C0",
    strokeWidth: 3.98693,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_452_5641",
    x1: 8.94411,
    y1: 9.54029,
    x2: 16.636,
    y2: 9.54029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B8270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#305C6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_452_5641",
    x1: 0.913147,
    y1: 9.54029,
    x2: 8.69964,
    y2: 9.54029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E7F98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BC0B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_452_5641",
    x1: 0.913147,
    y1: 14.3341,
    x2: 8.69964,
    y2: 14.3341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30435C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#299AA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_452_5641",
    x1: 9.00261,
    y1: 14.2734,
    x2: 16.6353,
    y2: 14.2734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E2C29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#323232"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAoa);
export default __webpack_public_path__ + "static/media/icon-aoa.e0397483d0977a0a464f3d07a109e23b.svg";
export { ForwardRef as ReactComponent };